import * as r from 'ramda'
import { isTruthy, isFalsy } from 'ramda-adjunct'

export { r }

const ra = { isTruthy, isFalsy }
export { ra }
